module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents-b/vantaggio_tecnologia.1c3d930113c2bb8f43cef7325483d747.jpg";